/**
 * Constantes para nombres de Foreign Keys en Supabase
 * Centralizadas para facilitar mantenimiento y consistencia
 */

export const FK = {
  // Lumisiales
  LUMISIALES_PROVINCIA: 'lumisiales_provincia_eclesiastica_fk_2025',
  LUMISIALES_DIOCESIS: 'lumisiales_diocesis_fk_2025',

  // Diócesis
  DIOCESIS_PROVINCIA: 'diocesis_provincia_eclesiastica_fk_2025',

  // Usuarios
  USUARIOS_PROVINCIA: 'usuarios_provincia_eclesiastica_fk_2025',

  // Solicitudes Usuario
  SOLICITUDES_PROVINCIA: 'solicitudes_usuario_provincia_eclesiastica_fk_2025',
  SOLICITUDES_DIOCESIS: 'solicitudes_usuario_diocesis_propuesta_id_new_fkey',
  SOLICITUDES_LUMISIAL: 'solicitudes_usuario_lumisial_propuesto_id_fkey',
  SOLICITUDES_ROL: 'solicitudes_usuario_rol_propuesto_id_fkey',
  SOLICITUDES_SOLICITANTE: 'solicitudes_usuario_solicitante_id_fkey',
  SOLICITUDES_RESUELTO_POR: 'solicitudes_usuario_resuelto_por_id_fkey',
} as const;

/**
 * Queries predefinidos para relaciones comunes
 */
export const RELATIONS = {
  // Lumisiales con relaciones completas
  LUMISIAL_FULL: `
    *,
    provincia_eclesiastica:provincias_eclesiasticas!${FK.LUMISIALES_PROVINCIA}(*),
    diocesis:diocesis!${FK.LUMISIALES_DIOCESIS}(*)
  `,

  // Diócesis con provincia eclesiástica
  // Diócesis con provincia eclesiástica
  DIOCESIS_FULL: `
    *,
    provincia_eclesiastica:provincias_eclesiasticas(*)
  `,

  // Solicitud Usuario con relaciones completas
  SOLICITUD_FULL: `
    *,
    solicitante:miembros!${FK.SOLICITUDES_SOLICITANTE}(id, nombres, apellidos, email),
    rol_propuesto:roles!${FK.SOLICITUDES_ROL}(id, nombre),
    provincia_eclesiastica_propuesta:provincias_eclesiasticas!${FK.SOLICITUDES_PROVINCIA}(id, nombre),
    diocesis_propuesta:diocesis!${FK.SOLICITUDES_DIOCESIS}(id, nombre, tipo),
    lumisial_propuesto:lumisiales!${FK.SOLICITUDES_LUMISIAL}(id, nombre),
    resuelto_por:miembros!${FK.SOLICITUDES_RESUELTO_POR}(id, nombres, apellidos)
  `,
} as const;
